import { useTranslation } from "@opendash/i18n";
import { Descriptions, Divider } from "antd";
import { DescriptionsItemType } from "antd/es/descriptions";
import { DescriptionsProps } from "antd/lib";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { useTicketData } from "../../hooks/useTicketData";
import { useTicketMeta } from "../../hooks/useTicketMeta";
import {
  TicketMetaFieldType,
  TicketTypedMetaField,
} from "../../types/TicketMeta";
import { MetaBoolean } from "./meta/MetaBoolean";
import { MetaDate } from "./meta/MetaDate";
import { MetaNumber } from "./meta/MetaNumber";
import { MetaSelect } from "./meta/MetaSelect";
import { MetaSelectParse } from "./meta/MetaSelectParse";
import { MetaString } from "./meta/MetaString";

type Props = {} & DescriptionsProps;

const MetaValueComponentMap: Record<
  TicketMetaFieldType,
  React.FC<{ meta: TicketTypedMetaField }>
> = {
  boolean: MetaBoolean,
  date: MetaDate,
  number: MetaNumber,
  select: MetaSelect,
  select_parse: MetaSelectParse,
  string: MetaString,
} as const;

export const TicketMetaDescription = observer((props: Props) => {
  const t = useTranslation();
  const ticketData = useTicketData();
  const meta = useTicketMeta(ticketData);

  const items: DescriptionsItemType[] = useMemo(
    () =>
      meta.map((field) => ({
        label: field.label,
        children: MetaValueComponentMap[field.type]
          ? React.createElement(MetaValueComponentMap[field.type], {
              meta: field,
            })
          : null,
      })),
    [meta]
  );

  if (items.length === 0) return <></>;

  return (
    <>
      <Divider children={t("maintenance:ticket.meta.title")} />
      <Descriptions column={1} items={items} bordered size="small" {...props} />
    </>
  );
});
